module.exports = __webpack_public_path__ + "img/gl.6401ee60.png";